import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app_route/App';
import reportWebVitals from './reportWebVitals';
import { PassCodeProvider } from './components/ProtectedComponentSetup/PassCodeContext/PassCodeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PassCodeProvider>
      <App />
    </PassCodeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();